import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as GrIcons from "react-icons/gr";
import { useTranslation } from "react-i18next";
import "./medicalClaim.css";
const variants = {
  enter: (direction: number) => {
    return {
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
};

import mtekLogo  from "../../../assets/images/mtek-logo.svg"


function MedicalExpenseClaim({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [sameCondtions, setSameCondtions] = useState<boolean>(false);
  const [isHospitalizedBefore, setIsHospitalizedBefore] =
    useState<boolean>(false);
  const [isValidE111, setValidE111] = useState<boolean>(false);
  useEffect(() => {
    setCurrentScreen("claim-medical");
    sessionStorage.setItem("claim-screens", "claim-medical");
  });

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    // setBeneficiaryInfo((prevState) => ({
    //   ...prevState,
    //   [name]: value,
    // }));
  };

  const saveDetails = () => {};
  return (
    <div className="container">
      <motion.div
        variants={variants}
        initial="enter"
        animate="center"
        exit={{ opacity: 0 }}
        className="steps-conatiner2"
      >
        <div
          className="image text-center mt-5 mb-3"
          onClick={() => navigate("/")}
        >
          <img src={mtekLogo} alt="travel icon" />
        </div>
        <div className="reg-title text-center mb-4">
          <span style={{ color: "#000000" }}>
            {t("medicalClaim.provideDetailsHeader")}
          </span>{" "}
          <span className="span-title">{t("medicalClaim.claimTitle")}</span> 
        </div>
        <div className="cancellation-input">
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="dateOfIllness">
                  {t("medicalClaim.dateOfIllnessLabel")}
                </label>
                <br />
                <input
                  id="dateOfIllness"
                  name="dateOfIllness"
                  type="date"
                  onChange={handleInputChange}
                  // value={travelInfo.departureCountry}
                  placeholder={t("medicalClaim.typeHere")}
                ></input>
              </motion.div>
            </div>
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="placeOfInjury">
                  {t("medicalClaim.placeOfInjuryLabel")}{" "}
                </label>
                <br />
                <input
                  id="placeOfInjury"
                  name="placeOfInjury"
                  type="text"
                  onChange={handleInputChange}
                  // value={travelInfo.placeOfInjury}
                  placeholder={t("medicalClaim.typeHere")}
                ></input>
              </motion.div>
            </div>
          </div>
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label
                  className="text-left-label mb-2"
                  htmlFor="detailOfIllness"
                >
                  {t("medicalClaim.detailOfIllnessLabel")}
                </label>
                <br />
                <input
                  id="detailOfIllness"
                  name="detailOfIllness"
                  type="text"
                  onChange={handleInputChange}
                  // value={travelInfo.detailOfIllness}
                  placeholder={t("medicalClaim.typeHere")}
                ></input>
              </motion.div>
            </div>
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label
                  className="text-left-label mb-2"
                  htmlFor="circumstancesOfIllness"
                >
                  {t("medicalClaim.circumstancesLabel")}{" "}
                </label>
                <br />
                <input
                  id="circumstancesOfIllness"
                  name="circumstancesOfIllness"
                  type="text"
                  onChange={handleInputChange}
                  // value={travelInfo.circumstancesOfIllness}
                  placeholder={t("medicalClaim.typeHere")}
                ></input>
              </motion.div>
            </div>
          </div>
          <div className="ky-input-wrapper">
            <motion.div
              animate={{ scale: [-0.7, 1] }}
              transition={{ duration: 1 }}
              className="ky-input-container mt-4"
            >
              <label className="text-left-label mb-2" htmlFor="postal">
                {t("medicalClaim.sameConditionsLabel")}{" "}
              </label>
              <br />
              <div className="countries d-flex mb-3">
                <button
                  className={
                    sameCondtions
                      ? "countries-selection multiple-country baggage-button isOption-active"
                      : "countries-selection multiple-country baggage-button"
                  }
                  onClick={() => setSameCondtions(true)}
                >
                  {t("medicalClaim.yes")}
                </button>
                <button
                  className={
                    !sameCondtions
                      ? "countries-selection one-country baggage-button isOption-active"
                      : "countries-selection one-country baggage-button"
                  }
                  onClick={() => setSameCondtions(false)}
                >
                  {t("medicalClaim.no")}
                </button>
              </div>
            </motion.div>
          </div>
          <motion.div
            animate={{ scale: [-0.7, 1] }}
            transition={{ duration: 1 }}
          >
            <div className="expense-disclaimer">
              <div className="expense-disclaimer-name">{t("medicalClaim.disclaimerTitle")}</div>
              <div className="expense-disclaimer-content">
                {t("medicalClaim.disclaimerContent")}
              </div>
            </div>
          </motion.div>

          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="postal">
                  {t("medicalClaim.hospitalizedLabel")}{" "}
                </label>
                <br />
                <div className="countries d-flex mb-3">
                  <button
                    className={
                      isHospitalizedBefore
                        ? "countries-selection multiple-country baggage-button isOption-active"
                        : "countries-selection multiple-country baggage-button"
                    }
                    onClick={() => setIsHospitalizedBefore(true)}
                  >
                    {t("medicalClaim.yes")}
                  </button>
                  <button
                    className={
                      !isHospitalizedBefore
                        ? "countries-selection one-country baggage-button isOption-active"
                        : "countries-selection one-country baggage-button"
                    }
                    onClick={() => setIsHospitalizedBefore(false)}
                  >
                    {t("medicalClaim.no")}
                  </button>
                </div>
              </motion.div>
            </div>
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="postal">
                  {t("medicalClaim.validE111Label")}{" "}
                </label>
                <br />
                <div className="countries d-flex mb-3">
                  <button
                    className={
                      isValidE111
                        ? "countries-selection multiple-country baggage-button isOption-active"
                        : "countries-selection multiple-country baggage-button"
                    }
                    onClick={() => setValidE111(true)}
                  >
                    {t("medicalClaim.yes")}
                  </button>
                  <button
                    className={
                      !isValidE111
                        ? "countries-selection one-country baggage-button isOption-active"
                        : "countries-selection one-country baggage-button"
                    }
                    onClick={() => setValidE111(false)}
                  >
                    {t("medicalClaim.no")}
                  </button>
                </div>
              </motion.div>
            </div>
          </div>
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label
                  className="text-left-label mb-2"
                  htmlFor="expensesClaimed"
                >
                  {t("medicalClaim.expensesClaimedLabel")}
                </label>
                <br />
                <input
                  id="expensesClaimed"
                  name="expensesClaimed"
                  type="number"
                  onChange={handleInputChange}
                  // value={travelInfo.expensesClaimed}
                  placeholder={t("medicalClaim.typeHere")}
                ></input>
              </motion.div>
            </div>
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label
                  className="text-left-label mb-2"
                  htmlFor="insuranceNumber"
                >
                  {t("medicalClaim.insuranceNumberLabel")}
                </label>
                <br />
                <input
                  id="insuranceNumber"
                  name="insuranceNumber"
                  type="text"
                  onChange={handleInputChange}
                  // value={travelInfo.insuranceNumber}
                  placeholder={t("medicalClaim.typeHere")}
                ></input>
              </motion.div>
            </div>
          </div>
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="amountClaimed">
                  {t("medicalClaim.amountClaimedLabel")}
                </label>
                <br />
                <input
                  id="amountClaimed"
                  name="amountClaimed"
                  type="number"
                  onChange={handleInputChange}
                  // value={travelInfo.amountClaimed}
                  placeholder={t("medicalClaim.typeHere")}
                ></input>
              </motion.div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="previous">
            <span
              onClick={(e) => {
                sessionStorage.setItem("claim-screens", "claim-options");
                setCurrentScreen("claim-options");
              }}
            >
              <span className="GrIcon me-2">
                <GrIcons.GrFormPreviousLink />
              </span>{" "}
              <span className="previous">{t("medicalClaim.previous")}</span>
            </span>
          </div>
          <div className="mt-5" onClick={() => saveDetails()}>
            <button className="pointer-btn next-btn">
              {" "}
              <span>
                {t("medicalClaim.proceed")}{" "}
                <span className="GrIcon ms-3">
                  <GrIcons.GrFormNextLink />
                </span>
              </span>{" "}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default MedicalExpenseClaim;
